<template>
  <v-container>
    <v-layout row wrap align-center>
      <v-flex>
        <div class="headline text-center">
          Upload Attachments for New Ticket
        </div>
        <TicketAttachmentsCode @codeGenerated="updateTicketAttachmentCode" />
        <UploadAttachment :guid="guid" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import TicketAttachmentsCode from "@/components/TicketAttachmentsCode.vue";
import UploadAttachment from "@/components/UploadAttachment.vue";

export default {
  components: {
    TicketAttachmentsCode,
    UploadAttachment
  },
  data: () => ({
    guid: ""
  }),
  methods: {
    updateTicketAttachmentCode: function(guid) {
      this.guid = guid;
    }
  }
};
</script>
